import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { MaterialComponentsModule } from '../../material-modules/material-components.module';


@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    MaterialComponentsModule
  ]
})
export class AuthModule { }
